import styled from 'styled-components';

import { Heading4, ContainerSt } from 'app/shared/ui';

export const MarketplaceFeaturedArticlesContainerSt = styled(ContainerSt)`
  margin-top: 56px;
  margin-bottom: 56px;
`;
